import React, { useContext, useEffect } from 'react'

import loginVerify from '../actions/loginVerify'

import { Session } from "../provider";

const Component = (props) => {
  
  const { state, dispatch } = useContext(Session);
    
  const handleInitz = () => {
    !state.submited && loginVerify()(dispatch);
  }

  useEffect(() => handleInitz(state, dispatch), [state]);

  return props.children
}

export default Component